import React from "react"

import { getView } from "@/onboarding/features/product/components/product_components/views/EditWrapper"
import { useAuthDescriptor } from "@/auth_descriptor/hooks"

const ComponentDisplay = ({ component }): JSX.Element => {
  const { isTourUi } = useAuthDescriptor()
  const View = getView(component)

  const referencedValueMessage = isTourUi
    ? "Cruise line-specific value. Edits possible during contracting."
    : ""

  return (
    <View component={component} editing hideRates referencedValueMessage={referencedValueMessage} />
  )
}

export default ComponentDisplay
